import React, { Component } from "react";
import axios from "axios";
import FeatherIcon from "feather-icons-react";

const PLAY_STORE_INTERNAL_TEST_URL = "https://play.google.com/apps/internaltest/4701443015529608578";

class Design7 extends Component {
  logout = () => {
    axios.post("logout").catch(() => {});
    window.localStorage.clear();
    window.location.replace(process.env.REACT_APP_EVIVESOMA);
  };

  render() {
    var user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : false;
    return (
      <footer className="evive-footer">
        <div className="container">
          <div className="evive-footer-panel">
            <div>
              <a className="evive-footer-brand" href="/">
                <img src="/logo192.png" alt="logo evive" />
                <span>{process.env.REACT_APP_NAME || "EviveSoma"}</span>
              </a>
              <p>
                Solution numérique de gestion scolaire pour connecter l’administration, les enseignants, les élèves et
                les parents.
              </p>
            </div>

            <div>
              <h3>Navigation</h3>
              <a href="#support">Services</a>
              <a href="#intervenant">Collaboration</a>
              <a href="#manager">Administration</a>
              <a href="#marketer">Optimisation</a>
            </div>

            <div>
              <h3>Espace personnel</h3>
              <a
                className="evive-store-link"
                href={PLAY_STORE_INTERNAL_TEST_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="evive-store-icon" aria-hidden="true">
                  <FeatherIcon icon="smartphone" size={17} />
                </span>
                <span>Télécharger l’app</span>
              </a>
              {user === false && (
                <button className="btn evive-primary-btn" type="button" data-bs-toggle="modal" data-bs-target="#popupLogin">
                  Connexion
                </button>
              )}
              {user !== false && (
                <button className="btn evive-danger-btn" type="button" onClick={() => this.logout()}>
                  <FeatherIcon icon="log-out" size={17} /> Déconnexion
                </button>
              )}
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Design7;
